import { z } from 'zod';
/** What an operator posts to create or edit a `SeatTier` (seat pricing tiers). */
export const seatTierWriteSchema = z.object({
    name: z.string().trim().min(1).max(60),
    markupPercent: z.number().int().min(0).max(500),
});
//# sourceMappingURL=seat-tier.js.map